/* Raw Blend product card: quick add to cart.
   Loaded as a module by snippets/rb-product-card.liquid, so however many cards a page has,
   the browser runs it once. One delegated submit listener handles every card, including
   cards added later (theme editor, tabs, AJAX).

   Posts the card's form to /cart/add.js, then hands the response to Dawn's own cart UI:
     cart-drawer        -> renderContents() re-renders the drawer and opens it
     cart-notification  -> renderContents() shows the "added" popup
     neither            -> go to the cart page (what Dawn does when cart type is "page")
   It also publishes Dawn's cartUpdate event so anything else listening stays in sync.
   The status words come from the form (data-msg-ok / data-msg-error), which the snippet fills
   from the theme's translations, so they are editable in "Edit default theme content".
   Without JavaScript the form still posts normally to /cart/add. */
if (!window.__rbCardQuickAdd) {
  window.__rbCardQuickAdd = true;

  const cartEl = () => document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  const addUrl = () => ((window.routes && window.routes.cart_add_url) || '/cart/add').replace(/\.js$/, '') + '.js';
  const cartUrl = () => (window.routes && window.routes.cart_url) || '/cart';

  const say = (form, text, ok) => {
    const msg = form.querySelector('.rb-card__msg');
    if (!msg) return;
    msg.classList.toggle('is-ok', !!ok);
    msg.textContent = text || '';
  };

  document.addEventListener('submit', async (evt) => {
    const form = evt.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('[data-rb-quick-add]')) return;
    evt.preventDefault();

    const btn = form.querySelector('[type="submit"]');
    if (!btn || btn.getAttribute('aria-disabled') === 'true') return;
    btn.setAttribute('aria-disabled', 'true');
    btn.classList.remove('is-added');
    btn.classList.add('is-loading');
    say(form, '');

    const cart = cartEl();
    const canRender = cart && typeof cart.renderContents === 'function' && typeof cart.getSectionsToRender === 'function';
    const body = new FormData(form);
    if (canRender) {
      body.append('sections', cart.getSectionsToRender().map((s) => s.id));
      body.append('sections_url', window.location.pathname);
      if (typeof cart.setActiveElement === 'function') cart.setActiveElement(btn);
    }

    let ok = false;
    try {
      const res = await fetch(addUrl(), {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
        body,
      });
      const data = await res.json();
      if (!res.ok || data.status) {
        say(form, data.description || data.message || form.dataset.msgError || 'Sorry, we could not add that.');
        return;
      }
      ok = true;

      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'rb-product-card', productVariantId: body.get('id'), cartData: data });
      }
      form.dispatchEvent(new CustomEvent('rb:cart:added', { bubbles: true, detail: { item: data } }));

      if (!canRender) {
        window.location = cartUrl();
        return;
      }
      if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
      cart.renderContents(data);
      say(form, form.dataset.msgOk || 'Item added to your cart', true);
    } catch (e) {
      console.error(e);
      say(form, form.dataset.msgError || 'Sorry, something went wrong. Please try again.');
    } finally {
      btn.classList.remove('is-loading');
      btn.removeAttribute('aria-disabled');
      if (ok) {
        btn.classList.add('is-added');
        setTimeout(() => { btn.classList.remove('is-added'); say(form, ''); }, 2600);
      }
    }
  });
}
